
import React, { useState, useMemo, useCallback, useRef } from "react";

// ** MUI Components
import {
  Box,
  Button,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
  Popover,
  FormControlLabel,
  Checkbox,
  InputAdornment,
} from "@mui/material";

import { CircularProgress, } from "@mui/material";

// ** Custom Components
import Icon from "components/icon";
import CustomTextField from "components/mui/text-field";
import { SimpleTreeView, TreeItem } from "@mui/x-tree-view";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CustomAutocomplete from "components/mui/autocomplete";


const AddService = ({ 
  open, 
  handleCloseDlg, 
}) => {
// const AddService = React.memo(({ 
//   open, 
//   handleClose, 
// }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const popoverContentRef = useRef(null);

  const isPopoverOpen = Boolean(anchorEl);

  // const memoizedServiceItems = useMemo(() => 
  //   serviceList.filter(x => x.isActive).map(service => (
  //     <TreeItem
  //       key={getItemId(service)}
  //       itemId={getItemId(service)}
  //       label={
  //         <FormControlLabel
  //           control={
  //             <Checkbox
  //               checked={selectedServices.some(
  //                 item => item.serviceOfferingID === service.serviceOfferingID
  //               )}
  //               onChange={() => handleToggle(service)}
  //             />
  //           }
  //           label={`${service.industryName} - ${service.serviceOfferingName}`}
  //           sx={{ ml: 0 }}
  //         />
  //       }
  //     />
  //   )),
  //   [serviceList, selectedServices, handleToggle, getItemId]
  // );

  const handleClick = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);  

 
  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={handleCloseDlg}>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #D9D9D9",
          paddingBottom: "20px !important",
        }}
      >
        <Typography variant="h4">Add Service</Typography>
        <IconButton onClick={handleCloseDlg}>
          <Icon icon="tabler:x" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box>        
          <CustomTextField
            label="Service"
            // value={selectedServices.length > 0 
            //   ? `${selectedServices.length} service(s) selected` 
            //   : ""}
            placeholder="Select"
            onClick={handleClick}
            readOnly
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <ArrowDropDownIcon />
                </InputAdornment>
              ),
            }}
          />
          <Popover
            open={isPopoverOpen}
            anchorEl={anchorEl}
            onClose={handleCloseDlg}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ horizontal: 'left' }}
            sx={{ 
              '& .MuiPopover-paper': { 
                width: '450px', 
                maxHeight: '340px',
                overflow: 'hidden',
                cursor:'pointer',
              } 
            }}
          >
            <Box sx={{
                  maxHeight: { xs: 180, md: 250, lg: 350, xl: 450 },
                  minWidth: 300,
                  p: 2,
                }}>
              <CustomTextField
                fullWidth
                placeholder="Search services..."
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icon icon="tabler:search" />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      {/* {localSearch && (
                        <IconButton
                          edge="end"
                          onClick={handleClearSearch}
                          aria-label="clear"
                          sx={{ mr: 2 }}
                        >
                          <Icon icon="tabler:x" />
                        </IconButton>
                      )} */}
                    </InputAdornment>
                  ),
                }}
                sx={{ mb: 2 }}
              />
              
              <Box 
                ref={popoverContentRef}
                // onScroll={handlePopoverScroll}
                sx={{ 
                  maxHeight: '200px', 
                  overflowY: 'auto',
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 1
                }}
              >
                <SimpleTreeView getItemId={(item) => item.serviceOfferingID}>
                  <TreeItem
                    label='Service 1'
                  />
                  {/* {memoizedServiceItems} */}
                  {/* {loadingRecords && (
                    <Box sx={{ p: 2, display: 'flex', justifyContent: 'center' , mb:5}}>
                      <CircularProgress size={20} />
                    </Box>
                  )} */}
                </SimpleTreeView>
              </Box>
            </Box>
          </Popover>
        </Box>
      </DialogContent>
      <DialogActions
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        padding: "20px 24px !important",
        boxShadow: `0px -4px 8px rgb(0, 0, 0, 0.1)`,
        zIndex: 1,
      }}
      >
        <Button variant="outlined" onClick={handleCloseDlg}>
          Cancel
        </Button>
        {/* <Button variant="contained" color="main" onClick={addService} disabled={selectedServices.length === 0}> */}
        <Button variant="contained" color="main">
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddService;
